/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GlobalAccessCapabilitySpec { 
    /**
     * Global Access Capability Email id
     */
    email?: string;
    /**
     * Global Access Capability Mode (Email or Form)
     */
    mode?: GlobalAccessCapabilitySpec.ModeEnum;
    /**
     * OAuth Enabled or Disabled
     */
    oauth_enabled?: boolean;
    /**
     * Global Access Capability Restriction
     */
    restricted?: boolean;
}
export namespace GlobalAccessCapabilitySpec {
    export type ModeEnum = 'EMAIL' | 'FORM';
    export const ModeEnum = {
        EMAIL: 'EMAIL' as ModeEnum,
        FORM: 'FORM' as ModeEnum
    };
}


